var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableGrapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.635,
    height: 17.66,
    viewBox: "0 0 15.635 17.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3380",
    "data-name": "Group 3380",
    transform: "translate(0.35 0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3176",
    "data-name": "Group 3176",
    transform: "translate(0 4.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3483",
    "data-name": "Path 3483",
    d: "M2071.682,135.56a2.219,2.219,0,0,1-2.217-2.217,2.2,2.2,0,0,1,.033-.381.35.35,0,0,1,.689.121,1.5,1.5,0,0,0-.022.259,1.517,1.517,0,1,0,3.011-.259.35.35,0,1,1,.689-.12,2.216,2.216,0,0,1-2.184,2.6Z",
    transform: "translate(-2066.083 -124.916)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3484",
    "data-name": "Path 3484",
    d: "M2086.828,135.558a2.219,2.219,0,0,1-2.217-2.217,2.277,2.277,0,0,1,.032-.379.35.35,0,0,1,.69.117,1.56,1.56,0,0,0-.022.262,1.517,1.517,0,1,0,3.033,0,1.558,1.558,0,0,0-.022-.262.35.35,0,1,1,.69-.118,2.265,2.265,0,0,1,.032.379A2.219,2.219,0,0,1,2086.828,135.558Z",
    transform: "translate(-2077.494 -124.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3485",
    "data-name": "Path 3485",
    d: "M2079.572,144.429a2.219,2.219,0,0,1-2.217-2.217,2.251,2.251,0,0,1,.032-.379.35.35,0,0,1,.69.118,1.54,1.54,0,0,0-.022.261,1.517,1.517,0,1,0,3.033,0,1.549,1.549,0,0,0-.022-.26.35.35,0,1,1,.689-.12,2.216,2.216,0,0,1-2.184,2.6Z",
    transform: "translate(-2072.027 -131.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3486",
    "data-name": "Path 3486",
    d: "M2064.111,121.962a2.217,2.217,0,1,1,0-4.434.35.35,0,1,1,0,.7,1.517,1.517,0,1,0,1.517,1.517.35.35,0,0,1,.7,0A2.219,2.219,0,0,1,2064.111,121.962Z",
    transform: "translate(-2060.377 -113.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3487",
    "data-name": "Path 3487",
    d: "M2094.4,121.962a2.219,2.219,0,0,1-2.217-2.217.35.35,0,0,1,.7,0,1.517,1.517,0,1,0,1.517-1.517.35.35,0,1,1,0-.7,2.217,2.217,0,1,1,0,4.434Z",
    transform: "translate(-2083.199 -113.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3488",
    "data-name": "Path 3488",
    d: "M2056.383,113.085h-.029a2.217,2.217,0,1,1,2.368-1.828.35.35,0,0,1-.689-.121,1.489,1.489,0,0,0,.022-.259,1.517,1.517,0,1,0-1.643,1.511.35.35,0,0,1-.028.7Z",
    transform: "translate(-2054.671 -106.821)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3489",
    "data-name": "Path 3489",
    d: "M2071.682,113.091a2.217,2.217,0,1,1,2.184-1.836.35.35,0,0,1-.689-.121,1.49,1.49,0,0,0,.022-.259,1.517,1.517,0,1,0-1.517,1.516.35.35,0,1,1,0,.7Z",
    transform: "translate(-2066.083 -106.821)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3490",
    "data-name": "Path 3490",
    d: "M2086.828,113.091a.35.35,0,1,1,0-.7,1.517,1.517,0,1,0-1.517-1.516,1.56,1.56,0,0,0,.022.262.35.35,0,0,1-.69.117,2.277,2.277,0,0,1-.032-.379,2.217,2.217,0,1,1,2.217,2.216Z",
    transform: "translate(-2077.494 -106.821)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3491",
    "data-name": "Path 3491",
    d: "M2062.271,102.673a.35.35,0,0,1-.344-.291,2.248,2.248,0,0,1-.032-.378,2.217,2.217,0,1,1,4.434,0,2.262,2.262,0,0,1-.031.373.35.35,0,0,1-.69-.115,1.559,1.559,0,0,0,.021-.258,1.517,1.517,0,1,0-3.011.26.35.35,0,0,1-.345.409Z",
    transform: "translate(-2060.377 -100.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3492",
    "data-name": "Path 3492",
    d: "M2077.415,102.674a.35.35,0,0,1-.344-.29,2.217,2.217,0,1,1,4.368,0,.35.35,0,1,1-.689-.12,1.542,1.542,0,0,0,.022-.26,1.517,1.517,0,1,0-3.033,0,1.5,1.5,0,0,0,.022.26.35.35,0,0,1-.345.411Z",
    transform: "translate(-2071.788 -100.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3493",
    "data-name": "Path 3493",
    d: "M2092.56,102.676a.35.35,0,0,1-.344-.291,2.278,2.278,0,0,1-.033-.381,2.217,2.217,0,1,1,4.4.38.35.35,0,1,1-.689-.12,1.517,1.517,0,1,0-3.011-.26,1.573,1.573,0,0,0,.023.263.35.35,0,0,1-.286.4A.355.355,0,0,1,2092.56,102.676Z",
    transform: "translate(-2083.199 -100.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3494",
    "data-name": "Path 3494",
    d: "M2101.973,113.091c-.06,0-.121,0-.18-.007a.35.35,0,0,1,.055-.7c.041,0,.083,0,.125,0a1.517,1.517,0,1,0-1.517-1.516,1.557,1.557,0,0,0,.023.269.35.35,0,0,1-.689.121,2.252,2.252,0,0,1-.034-.39,2.217,2.217,0,1,1,2.217,2.216Z",
    transform: "translate(-2088.905 -106.821)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3495",
    "data-name": "Path 3495",
    d: "M2079.255,121.962a2.217,2.217,0,1,1,2.217-2.217A2.219,2.219,0,0,1,2079.255,121.962Zm0-3.734a1.517,1.517,0,1,0,1.516,1.517A1.519,1.519,0,0,0,2079.255,118.228Z",
    transform: "translate(-2071.788 -113.504)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_1032",
    "data-name": "Line 1032",
    d: "M0,4.83a.35.35,0,0,1-.35-.35V0A.35.35,0,0,1,0-.35.35.35,0,0,1,.35,0V4.48A.35.35,0,0,1,0,4.83Z",
    transform: "translate(7.467 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3496",
    "data-name": "Path 3496",
    d: "M2094.841,87.339a.35.35,0,0,1-.184-.648,2.961,2.961,0,0,0,1.464-3.1,5.115,5.115,0,0,1-2.39,1.747l-.009,0a3.722,3.722,0,0,0-1.379.891.35.35,0,1,1-.549-.434,4.354,4.354,0,0,1,1.685-1.114c2.062-.812,2.39-2.1,2.4-2.15a.349.349,0,0,1,.662-.061,4.482,4.482,0,0,1,.308,1.737,3.592,3.592,0,0,1-1.828,3.075A.348.348,0,0,1,2094.841,87.339Z",
    transform: "translate(-2082.849 -82.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3497",
    "data-name": "Path 3497",
    d: "M2084.961,89.966h-.006a.35.35,0,0,1-.344-.356,3.363,3.363,0,0,1,1.867-2.855,6.566,6.566,0,0,1,1.768-.711.35.35,0,0,1,.341.568,1.307,1.307,0,0,0-.355,1.26l0,0-.646.27a1.768,1.768,0,0,1,0-1.142c-.905.368-2.246,1.16-2.271,2.628A.35.35,0,0,1,2084.961,89.966Z",
    transform: "translate(-2077.494 -85.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3177",
    "data-name": "Group 3177",
    transform: "translate(1.28 0.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3498",
    "data-name": "Path 3498",
    d: "M2061.526,87.339a.348.348,0,0,1-.183-.052,3.593,3.593,0,0,1-1.827-3.075,4.485,4.485,0,0,1,.308-1.737.35.35,0,0,1,.663.064c.012.051.341,1.336,2.4,2.148a4.352,4.352,0,0,1,1.685,1.114.35.35,0,1,1-.55.433,3.616,3.616,0,0,0-1.379-.891l-.009,0a5.116,5.116,0,0,1-2.389-1.748,2.962,2.962,0,0,0,1.463,3.1.35.35,0,0,1-.184.648Z",
    transform: "translate(-2059.865 -82.614)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3499",
    "data-name": "Path 3499",
    d: "M2074.695,89.966a.35.35,0,0,1-.35-.344c-.025-1.473-1.367-2.264-2.272-2.63a1.766,1.766,0,0,1,0,1.144l-.646-.27,0,0a1.307,1.307,0,0,0-.355-1.259.35.35,0,0,1,.341-.568,6.566,6.566,0,0,1,1.768.711,3.363,3.363,0,0,1,1.867,2.855.35.35,0,0,1-.344.356Z",
    transform: "translate(-2068.508 -85.456)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableGrapes);
export default __webpack_public_path__ + "static/media/table_grapes.5a61918f7a269d8c8e34efccc648e6e8.svg";
export { ForwardRef as ReactComponent };